import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box,
    Text,
    Stack,
    Flex,
    Badge,
    Divider,
    SimpleGrid,
    Button,
    ModalFooter,
    useColorModeValue,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const UpsellModal = ({ open, handleClose, upsellDetails = [], upsellAmount }) => {
    const { i18n } = useTranslation()
    const l = (en, ro) => (i18n.language === 'ro' ? ro : en)
    const cardBg      = useColorModeValue('gray.50', 'whiteAlpha.50')
    const borderColor = useColorModeValue('gray.200', 'whiteAlpha.300')

    return (
        <Modal isOpen={open} onClose={handleClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{l('Upsell details', 'Detalii upsell')}</ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    {upsellDetails.length === 0 ? (
                        <Text>{l('No upsells for this order.', 'Nu exista upsell-uri pentru aceasta comanda.')}</Text>
                    ) : (
                        <Stack spacing={4}>
                            {upsellDetails.map((item, idx) => (
                                <Box
                                    key={idx}
                                    p={4}
                                    bg={cardBg}
                                    borderWidth="1px"
                                    borderColor={borderColor}
                                    borderRadius="md"
                                >
                                    <Flex justify="space-between" align="center">
                                        <Text fontWeight="semibold">{item.name}</Text>
                                    </Flex>
                                </Box>
                            ))}

                            <Divider />
                            <Flex justify="space-between" fontWeight="bold">
                                <Text>{l('Total', 'Total')}</Text>
                                <Text>{upsellAmount} RON</Text>
                            </Flex>
                        </Stack>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button onClick={handleClose}>{l('Close', 'Inchide')}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default UpsellModal
